<header class="site-header">
  <div class="header-inner">
    <a class="brand" routerLink="/" (click)="closeMenu()" aria-label="SPLEX Innovation home">
      <img src="assets/img/Splex-Innovation-Logo.png" alt="SPLEX Innovation">
      <!-- <span class="brand-tag">Beta</span> -->
    </a>

    <button class="menu-toggle" type="button" (click)="toggleMenu()" [attr.aria-expanded]="menuOpen"
      aria-label="Toggle navigation">
      <i class="bi" [class.bi-list]="!menuOpen" [class.bi-x-lg]="menuOpen"></i>
    </button>

    <nav class="main-nav" [class.open]="menuOpen" aria-label="Main navigation">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
        (click)="closeMenu()">Home</a>
      <a routerLink="/aboutus" routerLinkActive="active" (click)="closeMenu()">About</a>
      <a routerLink="/services" routerLinkActive="active" (click)="closeMenu()">Services</a>
      <a routerLink="/pricing" routerLinkActive="active" (click)="closeMenu()">Pricing</a>
      <a routerLink="/contactus" routerLinkActive="active" (click)="closeMenu()">Contact</a>
      <a class="nav-cta mobile-cta" routerLink="/contactus" (click)="closeMenu()">Request for Quote</a>
    </nav>

    <a class="nav-cta desktop-cta" routerLink="/contactus" (click)="closeMenu()">Request for Quote</a>
  </div>
</header>